export const DEFAULT_LABEL_COLOR = '#9CA3AF';

export const getReadableTextColor = (backgroundColor: string): string => {
  const hex = backgroundColor.replace('#', '');
  if (!/^[0-9A-Fa-f]{6}$/.test(hex)) return '#111827';

  const channels = [0, 2, 4].map((offset) => {
    const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;

    return value <= 0.03928
      ? value / 12.92
      : ((value + 0.055) / 1.055) ** 2.4;
  });
  const luminance = 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];

  return luminance > 0.179 ? '#111827' : '#FFFFFF';
};
